import appInsights from './app-insights';
import ga from './ga-gtag';

const loadAnalytics = () => {
    appInsights.loadAppInsights();
    ga.initGoogleAnalytics();
};

export default loadAnalytics;
